import type { Map as LeafletMap } from "leaflet";
import L from "leaflet";
import type { Fence } from "../types/fence";
import { parseCircleFromWKT, parsePolygonFromWKT } from "./fence.utils";

export function focusMapOnFence(map: LeafletMap, fence: Fence): void {
	if (fence.type === 1) {
		const circle = parseCircleFromWKT(fence.area);
		if (circle) {
			map.flyTo(circle.center, 14);
		}
		return;
	}

	const polygon = parsePolygonFromWKT(fence.area);
	if (polygon && polygon.points.length > 0) {
		const bounds = L.latLngBounds(polygon.points);
		map.fitBounds(bounds, { padding: [50, 50] });
	}
}
